import { render, staticRenderFns } from "./resource-sharePage.vue?vue&type=template&id=759274cf"
import script from "./resource-sharePage.vue?vue&type=script&lang=js"
export * from "./resource-sharePage.vue?vue&type=script&lang=js"
import style0 from "./resource-sharePage.vue?vue&type=style&index=0&id=759274cf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports